import React, { useRef, useEffect, useState } from 'react'
import Input from '../Input'
import { ICONS } from '../Icon/getIcon'
import { Icon, Search, Select, Tooltip } from '@ohif/ui';
import { _editorMode, _roleType } from '@custom/Utils/constants/appConstants';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _commonUrls, _userUrls } from '@custom/Utils/constants/apiUrls';

// Assets
import { phoneIcon, mailIcon, mapIcon } from '../../../../ui/assets/svgIcons/icon'
import { sevenHIllsRoundImg } from '../../../../ui/assets/images/images'
import { useTheme } from "../../../src/contextProviders"
import { DELETE_REPORT_TEMPLATE } from '@custom/constant';
import { servicesManager } from '../../../../app/src/App';

interface Template {
  _id: String,
  _rev: String,
  type: String,
  templateHTML: HTMLElement,
  createdOn: string
  templateName: string,
  modality: string
  createdBy: string
  createdByName: string
}

const ReportTemplate = ({ templateList, handleShowTextEditor, viewHandler, search, setSearch, setModality, modality }) => {
  const { isDarkMode } = useTheme();
  const fileInputRef = useRef(null);
  const [_modalityOptions, setModalityOpton] = useState(null)
  const [searchInputValue, setSearchInputValue] = useState('');
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
  const { uiNotificationService } = servicesManager.services;

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        const modalityOptions = commonData?.result?.modality.map(modality => ({
          value: modality.value,
          label: modality.value,
        }));

        setModalityOpton(modalityOptions);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchCommonData();
  }, [])

  const handleSearch = (searchText) => {
    setSearch(searchText);
    setSearchInputValue(searchText);
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        let html = e.target.result;
        const parser = new DOMParser();
        // @ts-ignore
        const doc = parser.parseFromString(html, 'text/html');
        handleShowTextEditor(_editorMode.import, doc.body.innerHTML)
      };
      reader.readAsText(file);
    }
  };

  const handleImport = () => fileInputRef.current.click();


  const deleteHandler = async (template) => {
    const payload = {
      _id: template._id,
      _rev: template._rev
    };

    try {
      const response = await apiRequest({
        method: 'POST',
        endUrl: DELETE_REPORT_TEMPLATE,
        body: payload,
        headerType: 'json'
      });

      if (response?.status) {
        console.log("Template deleted successfully", response);

        uiNotificationService.show({
          title: "Success",
          message: response.msg,
          type: "success"
        });

        if (typeof setModality === 'function') {
          setModality(templateList.filter(t => t._id !== template._id));
        }
      } else {
        uiNotificationService.show({
          title: "Error",
          message: response?.msg || "Failed to delete template",
          type: "error"
        });
      }

    } catch (error) {
      uiNotificationService.show({
        title: "Error",
        message: "Failed to delete template",
        type: "error"
      });
      console.error("Error deleting template:", error);
    }
  };

  return (
    <div className='page__body'>
      <div className="details">
        <p className='bg-[#51A196] text-white font-semibold py-2 px-5 text-lg'>Select Template or Create</p>
        <div className='form form--innersec'>
          <div className='form__section'>
            <div className='relative max-w-[450px] mx-auto mb-[20px]'>
              <Search
                text="Template Name, Modality Wise"
                onSearchClick={handleSearch}
                value={searchInputValue}
                setValue={setSearchInputValue}
              />
            </div>
            {
              !search && <>
                {/* SECTION - CREATE & IMPORT  */}
                <section className='form__sectionTemplate mb-[20px] pb-[20px] ml-[24px] mr-[24px] border-b-[1px] border-[#CBCAD7]'>
                  <h1 className={`text-[22px] font-medium ${isDarkMode ? "text-[#ffffff]" : "text-[#100F14]"} mb-[25px]`}>Create & Import Templates </h1>
                  <div className='grid grid-cols-5 gap-8'>
                    <div onClick={() => handleShowTextEditor(_editorMode.default)} className='w-full text-center cursor-pointer'>
                      <div className='flex justify-center items-center h-[18rem] bg-white shadow-lg	'>
                        <div className='border-[#CBCAD7] w-5/6 h-[15.5rem] border flex justify-center items-center'>
                          <img className='w-8 h-8' src={`${ICONS.Plus}`} alt="plus_Icon" />
                        </div>
                      </div>
                      <p className='text-lg	text-[#51A196] mt-4 font-semibold capitalize'>New Template</p>
                    </div>
                    <input ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileSelect} className='ml-2' type='file' />
                    <div onClick={handleImport} className='w-full text-center cursor-pointer	'>
                      <div className='flex justify-center items-center h-[18rem] bg-white shadow-lg '>
                        <div className='border-[#CBCAD7] w-5/6 h-[15.5rem] border flex justify-center items-center'>
                          <div className='border-[#51A196] border rounded-md flex justify-center items-center gap-1 py-1 px-3'>
                            <img className='w-7 h-7' src={`${ICONS.Import}`} alt="import_Icon" />
                            <span className='text-sm text-[#51A196] font-medium'>Import File</span>
                          </div>
                        </div>
                      </div>
                      <p className='text-lg	text-[#51A196] mt-4 font-semibold capitalize'>Import Template</p>
                    </div>
                  </div>
                </section>
              </>
            }
            {/* SECTION - TEMPLATES LISTING */}
            <section className='form__sectionTemplate mr-[24px] ml-[24px]'>
              <div className='flex justify-between items-center mb-[25px]'>
                <h1 className={`text-[22px] font-medium ${isDarkMode ? "text-[#ffffff]" : "text-[#100F14]"} mb-[25px]`}>Templates</h1>
                {
                  role != _roleType.pathologist &&
                  <div className='flex justify-s items-center' style={{ minWidth: '250px' }}>
                    <p className={`text-[12px] font-medium mr-2 ${isDarkMode ? "text-[#ffffff]" : "text-[#100F14]"}`}>Modality Wise:</p>
                    <Select
                      className="flex-2"
                      id="modality-wise"
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      isClearable={true}
                      isDisabled={false}
                      isSearchable={true}
                      onChange={(value) => setModality(value)}
                      options={_modalityOptions}
                      placeholder="Modality Wise:..."
                      value={modality}
                    />
                  </div>
                }
              </div>
              <div className='grid grid-cols-5 gap-8'>
                {templateList &&
                  templateList?.map((template: Template, index: any) => {
                    return <div key={index} className='w-full text-center cursor-pointer'>
                      <div onClick={() => viewHandler(template)} className='flex justify-center items-center  h-[18rem] shadow-xl bg-white' >
                        <div className='border-[#CBCAD7] border w-5/6 h-[15.5rem]  p-2 overflow-hidden'>
                          <div style={{
                            transform: 'scale(0.2)',  // Scale the content to fit inside
                            width: '100%',
                            height: '100%',
                            display: 'block',
                            minWidth: '1100px',
                            transformOrigin: 'top left'
                          }}>
                            <section className="flex flex-row p-2">
                              <div className="basic-1/3 p-4">
                                <div className="h-full">
                                  <div className='flex flex-row h-full w-full'>
                                    <div className="block mx-auto" style={{ width: '150px' }}>
                                      <img src={sevenHIllsRoundImg} alt="" className='block mx-auto' />
                                    </div>
                                    <div className='border-l-2 border-[#51A196] ml-4 h-full'></div>
                                  </div>
                                </div>
                              </div>
                              <div className="basic-2/3 p-4 w-full ml-4">
                                <div>
                                  <p className='text-[#51A196] text-[18px]  font-semibold'>Test Center</p>
                                  <p className='text-[16px] font-semibold'>Dr. Oshein Orlando</p>
                                  <p className='text-[14px] text-[#49475A]'>Board Certified Cardiologist & Surgeon</p>
                                </div>

                                <div className='flex flex-row gap-4 border-t-2 border-[#51A196] pt-2 mt-2'>
                                  <div className='flex flex-row gap-2'>
                                    <img src={phoneIcon} alt="" />
                                    <p className='text-[14px] font-normal color-[#535353]'>+1 (442)-222-4409</p>
                                  </div>
                                  <div className='flex flex-row gap-2'>
                                    <img src={mailIcon} alt="" />
                                    <p className='text-[14px] font-normal color-[#535353]'>mad@gmail.com</p>
                                  </div>
                                  <div className='flex flex-row gap-2'>
                                    <img src={mapIcon} alt="" />
                                    <p className='text-[14px] font-normal color-[#535353]'>H14 Abc </p>
                                  </div>
                                </div>

                              </div>
                            </section>

                            <section className='bg-[#51A196] p-2'>
                              <p className='text-[17.53px] font-semibold text-white'>Healthcare Form</p>
                            </section>

                            <div
                              style={{
                                width: '100%',
                                height: '100%',
                                display: 'block',
                              }}
                              dangerouslySetInnerHTML={{ __html: template?.templateHTML || '' }}
                            />
                          </div>
                        </div>
                      </div>
                      {template.createdByName ? (
                        <Tooltip
                          content={
                            template.createdBy === userId
                              ? "Created by You"
                              : `Created by ${template.createdByName}`
                          }
                        >
                          <p className="text-lg text-[#51A196] mt-4 font-semibold capitalize">
                            {template.templateName}
                          </p>
                        </Tooltip>
                      ) : (
                        <p className="text-lg text-[#51A196] mt-4 font-semibold capitalize">
                          {template.templateName}
                        </p>
                      )}

                      {(template?.createdBy === userId || role === _roleType.admin || role === _roleType.hospitalSuperadmin) && <button onClick={() => deleteHandler(template)}>
                        <Icon name="delete-icon"></Icon>
                      </button>}
                    </div>
                  })
                }
                {
                  templateList.length == 0 && <div className='w-screen flex justify-center items-center'><h1 className={`text-[22px] font-medium ${isDarkMode ? "text-[#ffffff]" : "text-[#100F14]"} `}>No Results Found...</h1></div>
                }
              </div>
            </section>
          </div>

        </div>
      </div>
    </div>
  )
}

export default ReportTemplate
